import { createFileRoute } from '@tanstack/react-router';
import { CreateAgentSheet } from '@/pages/referrer/agents/create-agent-sheet';

export const Route = createFileRoute('/referrer/_layout/agents/_layout/new')({
  component: () => <CreateAgentSheet />,
});
